import axios from "axios";
import {message} from "antd";

// const
const ROLE_CONFIG_MANAGEMENT_UPDATE_DATA = "roleConfigManagement/ROLE_CONFIG_MANAGEMENT_UPDATE_DATA";
const ROLE_CONFIG_MANAGEMENT_STORE_ROLES = "roleConfigManagement/ROLE_CONFIG_MANAGEMENT_STORE_ROLES";
const ROLE_CONFIG_MANAGEMENT_STORE_DEPLOYMENTS = "roleConfigManagement/ROLE_CONFIG_MANAGEMENT_STORE_DEPLOYMENTS";
const ROLE_CONFIG_MANAGEMENT_STORE_MENUS = "roleConfigManagement/ROLE_CONFIG_MANAGEMENT_STORE_MENUS";
const ROLE_CONFIG_MANAGEMENT_STORE_REDO_MENUS = "roleConfigManagement/ROLE_CONFIG_MANAGEMENT_STORE_REDO_MENUS";
// const ROLE_CONFIG_MANAGEMENT_TOGGLE_MODAL = "roleConfigManagement/ROLE_CONFIG_MANAGEMENT_TOGGLE_MODAL";
const ROLE_CONFIG_MANAGEMENT_TOGGLE_LOADING = "roleConfigManagement/ROLE_CONFIG_MANAGEMENT_TOGGLE_LOADING";

// reducer
export const roleConfigManagement = (state = {

  loading: false,

  role: "",
  roles: [],
  deployment: "",
  deployments: [],
  expandedRowKeys: [],
  allExpandedKeys: [],

  menus: [],
}, action) => {
  switch (action.type) {
    case ROLE_CONFIG_MANAGEMENT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case ROLE_CONFIG_MANAGEMENT_STORE_ROLES:
      return {
        ...state,
        roles: action.data,
        role: action.data[0].id
      };
    case ROLE_CONFIG_MANAGEMENT_STORE_DEPLOYMENTS:
      return {
        ...state,
        deployment: "all",
        deployments: action.data
      };
    case ROLE_CONFIG_MANAGEMENT_STORE_MENUS:
      const allExpandedKeys = [];
      const loop1 = (data) => {
        data.map(item => {
          if (item.hasOwnProperty("children")) {
            if (item.children && item.children.length) {
              allExpandedKeys.push(item.id);
              loop1(item.children);
            } else {
              delete item.children;
            }
          }
        });
      };
      loop1(action.data);
      return {
        ...state,
        menus: action.data,
        allExpandedKeys: allExpandedKeys,
        expandedRowKeys: [],
      };
    case ROLE_CONFIG_MANAGEMENT_STORE_REDO_MENUS:
      const loop2 = (data) => {
        data.map(item => {
          if (item.hasOwnProperty("children")) {
            if (item.children && item.children.length) {
              loop2(item.children);
            } else {
              delete item.children;
            }
          }
        });
      };
      loop2(action.data);
      return {
        ...state,
        menus: action.data
      };
    // case ROLE_CONFIG_MANAGEMENT_TOGGLE_MODAL:
    //   return {
    //     ...state,
    //     modalVisible: action.data.modalVisible,
    //     modalTitle: action.data.modalTitle,
    //     modalContent: action.data.modalContent,
    //     modalOk: action.data.modalOk,
    //     modalCancel: action.data.modalCancel,
    //     onOk: action.data.onOk,
    //     onCancel: action.data.onCancel
    //   };
    case ROLE_CONFIG_MANAGEMENT_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateRoleConfigManagementData = (data) => {
  return {
    type: ROLE_CONFIG_MANAGEMENT_UPDATE_DATA,
    data: data
  }
};

/**
 * get all deployments by enterprise id
 */
export const getDeployments = (enterpriseId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-backend/deployments/web/${enterpriseId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeDeployments(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all deployments
 */
export const storeDeployments = (deployments) => {
  return {
    type: ROLE_CONFIG_MANAGEMENT_STORE_DEPLOYMENTS,
    data: deployments
  }
};

/**
 * get all roles and menus by enterprise id
 */
export const getRolesAndMenus = (enterpriseId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-user/enterprisesRoles?page=` + 0 + `&size=` + 1000 + `${!!enterpriseId ? `&enterpriseId=${enterpriseId}` : ``}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeRoles(response.data.content));
        dispatch(getMenus(enterpriseId, response.data.content[0].id));
        dispatch(toggleLoading(false));
      }
    });
};

/**
 * store all roles
 */
export const storeRoles = (roles) => {
  return {
    type: ROLE_CONFIG_MANAGEMENT_STORE_ROLES,
    data: roles
  }
};

/**
 * get all menu by enterprise id and role id
 */
export const getMenus = (enterpriseId, roleId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-menu/getMenusAndPrivilege?roleId=${roleId}${!!enterpriseId ? `&enterpriseId=${enterpriseId}` : ``}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeMenus(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all menus
 */
export const storeMenus = (menus) => {
  return {
    type: ROLE_CONFIG_MANAGEMENT_STORE_MENUS,
    data: menus
  }
};

/**
 * redo menu by enterprise id and role id
 */
export const redoMenus = (enterpriseId, roleId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-menu/getMenusAndPrivilege?roleId=${roleId}${!!enterpriseId ? `&enterpriseId=${enterpriseId}` : ``}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeRedoMenus(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store redo menus
 */
export const storeRedoMenus = (menus) => {
  return {
    type: ROLE_CONFIG_MANAGEMENT_STORE_REDO_MENUS,
    data: menus
  }
};

/**
 * submit role menu privilege
 */
export const submitRoleMenuPrivilege = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  const roleMenuPrivileges = [];
  const loop3 = (menus) => {
    menus.map(menu => {
      if (menu.privilege !== null && menu.privilege.length > 0) {
        menu.privilege.forEach(code => {
          roleMenuPrivileges.push({roleId: data.roleId, menuId: menu.id, privilege: code});
        });
      }
      if (menu.hasOwnProperty("children")) {
        if (menu.children && menu.children.length) {
          loop3(menu.children);
        }
      }
    });
  };
  loop3(data.menus);
  console.info(roleMenuPrivileges);
  axios({
    method: "post",
    url: `/api-menu/submitRoleMenuPrivilege/${data.roleId}`,
    contentType: "application/json",
    withCredentials: true,
    data: roleMenuPrivileges,
  }).then(
    response => {
      if (response.status === 200) {
        console.log("success submit role menu privilege");
        message.success("菜单权限配置提交成功！");
        dispatch(redoMenus(data.enterpriseId, data.roleId));
      } else {
        console.error("fail to submit role menu privilege");
        message.error("菜单权限配置提交失败！");
        dispatch(toggleLoading(false));
      }
    }
  );
};

// /**
//  * toggle modal
//  */
// export const toggleModal = (show) => {
//   return {
//     type: ROLE_CONFIG_MANAGEMENT_TOGGLE_MODAL,
//     data: show
//   }
// };

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: ROLE_CONFIG_MANAGEMENT_TOGGLE_LOADING,
    data: show
  }
};

/***
 * empty function
 * @param id
 */
export const filterMenu = (data) => {

}
